import axiosInstance from "../../api/axiosConfig";

export const getProductDetails = (id: string) => {
  return axiosInstance.get(`/products/${id}`);
};
